import { useEffect, useRef } from "react";

export function usePhoneInputLimiter(maxDigits: number = 10) {
  const phoneInputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    const input = phoneInputRef.current;
    if (!input) return;

    const handleBeforeInput = (e: InputEvent) => {
      const target = e.target as HTMLInputElement;
      const digits = target.value.replace(/\D/g, "").replace(/^1/, ""); // remove +1
      const inputType = (e as any).inputType;
      if (digits.length >= maxDigits && inputType !== "deleteContentBackward") {
        e.preventDefault();
      }
    };
    input.addEventListener("beforeinput", handleBeforeInput as EventListener);
    return () => {
      input.removeEventListener("beforeinput", handleBeforeInput as EventListener);
    };
  }, [maxDigits]);

  return phoneInputRef;
}